import React from 'react';

// 3rd Party
import Slider from 'react-slick';
import ExecutionEnvironment from 'exenv';
import CountUp from 'react-countup';

class Counter extends React.Component {
  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);
    this.mouseOverHandler = this.mouseOverHandler.bind(this);

    let counterItemsEndValues = [];

    this.props.content.items.map(() => {
      counterItemsEndValues = [...counterItemsEndValues, 0];
    });

    this.state = {
      animationFinished: false,
      counterItems: [],
      counterItemsEndValues,
      sliderSettings: {
        adaptiveHeight: false,
        arrows: true,
        dots: false,
        infinite: true,
        nextArrow: React.createElement('div', null, 'next'),
        prevArrow: React.createElement('div', null, 'prev'),
        responsive: [
          { breakpoint: 640 },
          {
            breakpoint: 100000,
            settings: 'unslick'
          }
        ],
        slidesToScroll: 3,
        slidesToShow: 3,
        speed: 500
      }
    };
  }

  handleScroll () {
    const section = document.querySelector('section.counter');

    if (this.isInViewport(section) && !this.state.animationFinished) {
      this.setState({ animationFinished: true });

      const statItems = document.querySelectorAll('section.counter .stat-item');

      for (let counter = 0; counter < this.props.content.items.length; counter++) {
        setTimeout(() => (
          () => {
            statItems[counter].querySelector('img').src = statItems[counter].querySelector('img').src;

            const counterItemsEndValues = this.state.counterItemsEndValues;

            counterItemsEndValues[counter] = this.props.content.items[counter].count;
            this.setState({ counterItemsEndValues });
          })(counter), 1000 * counter);
      }
    }
  }


  // @see https://gist.github.com/jjmu15/8646226
  isInViewport(element) {
    const html = document.documentElement,
      rect = element.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth)
    );
  }

  mouseOverHandler(event) {
    const animatedImg = event.target.querySelector('img');

    // Set the src new, the gif will animate again
    animatedImg.src = animatedImg.src;
  }

  componentDidMount() {
    if (ExecutionEnvironment.canUseDOM) {
      window.addEventListener('scroll', this.handleScroll);
    }

    const picto = document.querySelectorAll('section.counter .stat-item');

    for (const item of picto) {
      item.addEventListener('mouseenter', this.mouseOverHandler);
    }
  }

  componentWillUnmount() {
    if (ExecutionEnvironment.canUseDOM) {
      window.removeEventListener('scroll', this.handleScroll);
    }

    const picto = document.querySelectorAll('section.counter .stat-item');

    for (const item of picto) {
      item.removeEventListener('mouseenter', this.mouseOverHandler);
    }
  }

  render() {
    return (
      <section className="counter">
        <div className="wrap">
          <Slider {...this.state.sliderSettings}>
            {this.props.content.items.map((item, index) =>
              <div key={index} className="stat-item">
                <img width="70" height="80" src={`${require(`../../../public/img/counter-icons/${item.image}`)}`} />
                <div className="heading">{item.title}</div>
                <CountUp duration={2} start={0} end={this.state.counterItemsEndValues[index]} useGrouping={true} separator="." className="data" ref={countUp => {
                  this.state.counterItems[index] = countUp;
                }} />
              </div>
            )}
          </Slider>
        </div>
      </section>
    );
  }
}

export default Counter;


// WEBPACK FOOTER //
// ./src/sections/counter/counter.jsx